export const SET_TOURISTS = 'SET_TOURISTS';
export const DELETE_SAVED_TOURIST = 'DELETE_SAVED_TOURIST';
export const DELETE_SAVED_TOURIST_SUCCESS = 'DELETE_SAVED_TOURIST_SUCCESS';
export const DELETE_SAVED_TOURIST_FAIL = 'DELETE_SAVED_TOURIST_FAIL';
